var map = {
	"./01.png": 3016,
	"./02.png": 54,
	"./CoverImg.png": 7788,
	"./L.png": 822,
	"./Munguu.png": 5122,
	"./Vector.png": 2035,
	"./earth.png": 1372,
	"./effect-1.png": 2919,
	"./effect-2.png": 5814,
	"./effect-3.png": 3816,
	"./logo.png": 6338,
	"./moon.png": 9682,
	"./photo.png": 2229,
	"./tseg.png": 6505,
	"./uram.png": 9785,
	"./yozla.png": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;